import { useState, useContext } from "react";
import BeneficialOwnershipTab from "components/PLCTABS/BeneficialOwnershipTab";
import UpdateCompanyDetailsContext from "context/UpdateCompanyDetails";

const BeneficialOwners = ({ handleGoBack, handleGoForward }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { isInUpdateCompanyDetailsContext, transactions } = useContext(UpdateCompanyDetailsContext);

  return (
    <div className="relative mt-2">
      <BeneficialOwnershipTab
        handleBackBtn={handleGoBack}
        handleNextBtn={handleGoForward}
        submitBtnLabel="Save and Proceed"
        isSubmitting={isSubmitting}
        isInUpdateCompanyDetailsContext={isInUpdateCompanyDetailsContext}
        transactions={transactions}
      />
    </div>
  );
};

export default BeneficialOwners;
